<template>
  <div class="payPage w1200">
    <div class="title">
      <span>订单支付</span>
    </div>
    <!-- 购票信息 -->
    <div class="ticketInfo">
      <h3>购票信息</h3>
      <div class="ticketItem">
        <div class="itemLeft">
          <div class="cover">
            <img :src="goods.thumb" alt="" />
          </div>
          <div class="itemInfo">
            <h3>{{ goods.title }}</h3>
            <span class="price"
              >购票单价：<i>¥{{ goods.price }}</i></span
            >
            <p class="tips">注意：购买后不支持退款、转让，请确认活动时间后再提交订单</p>
          </div>
        </div>
        <div class="amount">x{{ goods.num }}</div>
      </div>
    </div>
    <!-- 参会人信息 -->
    <div class="participator">
      <div class="titleBox">
        <h3>参会人信息</h3>
      </div>
      <ul class="peopleInfo">
        <li v-for="(item, index) in user" :key="item.top">
          <span class="label">参会人{{ index + 1 }}：</span>
          <span class="name" style="min-width: 80px">{{ item.name }}</span>
          <span class="phone">{{ item.phone }}</span>
        </li>
      </ul>
    </div>
    <!-- 支付方式 -->
    <div class="payMethods">
      <div class="titleBox">
        <h3>支付方式</h3>
      </div>
      <div class="payment">
        <span class="label">支付平台：</span>
        <a-radio-group v-model:value="payValue">
          <a-radio :value="1"><img src="@/assets/images/icon_weixinPay.png" alt="" /> 微信支付</a-radio>
          <a-radio :value="2"><img src="@/assets/images/icon_alipay.png" alt="" /> 支付宝</a-radio>
        </a-radio-group>
      </div>
    </div>
    <!-- 使用优惠券 -->
    <div class="discountBox">
      <div class="boxWrap">
        <a-collapse v-model:activeKey="collapseKey" expandIconPosition="right" ghost>
          <a-collapse-panel key="1" header="使用优惠券">
            <a-tabs v-model:activeKey="tabsKey">
              <a-tab-pane key="1">
                <template #tab>
                  <span> 可使用优惠券({{ use_voucher_num }}) </span>
                </template>
                <ul class="couponList">
                  <a-radio-group v-model:value="discountValue">
                    <li
                      :class="discountValue == item.id ? 'selected' : ''"
                      @click="checkCoupon(item.id)"
                      v-for="item in couponList"
                      :key="item.id"
                    >
                      <img src="@/assets/images/select_icon.png" class="selecIcon" v-show="discountValue == item.id" />
                      <div class="firstRow">
                        <span class="money">
                          <i>{{ item.money }}</i> 元
                        </span>
                        <span class="name" :title="item.name">
                          {{ item.name }}
                        </span>
                      </div>
                      <div class="secondRow">
                        <span class="mini_num"> 满{{ item.mini_num }}可用 </span>
                        <span class="end_at">
                          {{ item.end_at }}
                        </span>
                      </div>
                      <div class="rule" @click.stop="lookRule(item.content)">具体规则请点击查看</div>
                      <a-radio :value="item.id" @click="radioClick(item.id)"></a-radio>
                    </li>
                  </a-radio-group>
                </ul>
              </a-tab-pane>

              <a-tab-pane key="2">
                <template #tab>
                  <span> 不可用优惠券({{ not_voucher_num }}) </span>
                </template>
                <ul class="couponList NoUse">
                  <li v-for="item in NoCouponList" :key="item.id">
                    <img src="@/assets/images/icon_coupon_used.png" class="selecIcon" v-if="item.use_type == 1" />
                    <img src="@/assets/images/icon_coupon_no.png" class="selecIcon" v-else-if="item.use_type == 2" />
                    <img src="@/assets/images/icon_coupon_past.png" class="selecIcon" v-else />
                    <div class="firstRow">
                      <span class="money">
                        <i>{{ item.money }}</i> 元
                      </span>
                      <span class="name" :title="item.name">
                        {{ item.name }}
                      </span>
                    </div>
                    <div class="secondRow">
                      <span class="mini_num"> 满{{ item.mini_num }}可用 </span>
                      <span class="end_at">
                        {{ item.end_at }}
                      </span>
                    </div>
                    <div class="rule" @click="lookRuleNo(item.content)">不可用的原因请点击查看</div>
                  </li>
                </ul>
              </a-tab-pane>
            </a-tabs>
          </a-collapse-panel>
        </a-collapse>
      </div>
      <div class="deduction">
        <span>
          金额抵用：<i>￥{{ deduction }}</i>
        </span>
      </div>
    </div>
    <!-- 支付金额 -->
    <div class="payMoney">
      <div class="titleBox">
        <h3>支付金额</h3>
      </div>
      <ul>
        <li>
          <span>
            <span class="label">购票总价：</span>
            <i>￥{{ price.total_amounts }}</i>
          </span>
        </li>
        <li v-if="price.member_discount > 0">
          <span>
            <span class="label">会员优惠：</span>
            <i>￥－{{ price.member_discount }}</i>
          </span>
        </li>
        <li v-if="price.discount_price > 0">
          <span>
            <span class="label">活动优惠：</span>
            <i>￥－{{ price.discount_price }}</i>
          </span>
        </li>

        <li v-if="deduction > 0">
          <span>
            <span class="label">优惠券：</span>
            <i>￥－{{ deduction }}</i>
          </span>
        </li>
        <li>
          <span>
            <span class="label">应付金额：</span>
            <i class="total">￥{{ priceTotal }}</i>
          </span>
        </li>
      </ul>
      <div class="payBtn">
        <a-button type="primary" size="large" @click="confirmPay">确认付款</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/paypage.less'
import { Modal } from 'ant-design-vue'
export default {
  name: 'PayPage',
  props: ['orderId'],
  data() {
    return {
      payValue: 1,
      collapseKey: '',
      tabsKey: '1',
      discountValue: '',
      //   四个模块信息S
      goods: {},
      user: [],
      voucher: {},
      price: {},
      //   四个模块信息E
      use_voucher_num: 0,
      not_voucher_num: 0,
      couponList: [
        {
          id: 1,
          money: 500,
          name: '付费直播课程优惠券',
          mini_num: '500',
          end_at: '有效期至：2022.12.12',
        },
        {
          id: 2,
          money: 400,
          name: '付费直播课程优惠券',
          mini_num: '500',
          end_at: '有效期至：2022.12.12',
        },
      ],
      NoCouponList: [
        {
          id: 1,
          money: 500,
          name: '付费直播课程优惠券',
          mini_num: '500',
          end_at: '有效期至：2022.12.12',
        },
        {
          id: 2,
          money: 400,
          name: '付费直播课程优惠券',
          mini_num: '500',
          end_at: '有效期至：2022.12.12',
        },
      ],
      deduction: 0,
      priceTotal: 0,
    }
  },
  mounted() {
    this.getOrderInfo()
  },
  methods: {
    async getOrderInfo() {
      const { data: res } = await this.$http.post('/offline/buy_order_offline', {
        order_no: this.orderId,
      })
      console.log(res)
      this.goods = res.order.goods
      this.user = res.order.user
      this.voucher = res.order.voucher
      this.price = res.order.price
      this.use_voucher_num = res.order.voucher.use_voucher_num
      this.not_voucher_num = res.order.voucher.not_voucher_num
      this.couponList = res.order.voucher.use_voucher
      this.NoCouponList = res.order.voucher.not_voucher
      this.PriceTotal()
    },
    PriceTotal() {
      this.priceTotal =
        this.price.total_amounts - (this.price.member_discount + this.price.discount_price + this.deduction)
      if (this.priceTotal < 0) {
        this.priceTotal = 0
      }
    },
    checkCoupon(id) {
      this.radioClick(id)
      this.couponList.forEach((item) => {
        if (item.id == id) {
          this.deduction = Number(item.money)
          return
        }
      })
      this.PriceTotal()
    },
    radioClick(id) {
      console.log(id)
      this.discountValue = id
    },
    lookRule(content) {
      Modal.info({
        title: '使用规则',
        content: content,
      })
    },
    lookRuleNo(content) {
      Modal.info({
        title: '不可用的原因',
        content: content,
      })
    },
    confirmPay() {
      if (this.payValue == 1) {
        this.$router.push({
          name: 'WXPayment',
        })
      } else {
        console.log('支付宝')
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
